import type { EventSpaceSelection } from '@/store/models/events';
import type { SpaceWithAvailability } from '@/store/models/spaces';

const normalizeSetupCode = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[-_\s]/g, '');

export const getRoomSetupCount = (
  setupCode: string,
  details: SpaceWithAvailability | undefined
): number | undefined => {
  if (!details) {
    return undefined;
  }

  const layoutCapacity =
    details.supportedRoomLayouts?.find(
      (layout) => normalizeSetupCode(layout.code) === normalizeSetupCode(setupCode)
    )?.capacity ?? 0;

  return layoutCapacity > 0 ? layoutCapacity : details.roomCapacity;
};

export const getRoomSetupCapacity = (
  selection: EventSpaceSelection | undefined,
  details: SpaceWithAvailability | undefined,
  fallbackCapacity?: number
): number | undefined => {
  const setupCodes = selection?.selectedSetupCodes ?? [];

  if (details && setupCodes.length > 0) {
    return setupCodes.reduce((total, code) => total + (getRoomSetupCount(code, details) ?? 0), 0);
  }

  return details?.roomCapacity ?? selection?.setupCapacity ?? fallbackCapacity;
};
